import * as React from 'react'

const EntityStepBar = (props: { children: any }) => {
  return <div className='flex justify-start bg-light-grey3 w100'>{props.children}</div>
}

export default EntityStepBar



// WEBPACK FOOTER //
// ./src/components/ui/entity/EntityStepBar.tsx